
























































import Vue from 'vue'
import { mapState } from 'vuex'

import { Company, Location } from '@/models'
import { LaunchpadService } from '@/services'

export default Vue.extend({
  name: 'LaunchpadMicroApp',
  components: {
    LaunchpadV1: () => import('./launchpad/LaunchpadV1.vue'),
    LaunchpadV2: () => import('./launchpad/LaunchpadV2.vue'),
  },
  data() {
    return {
      location: {} as Location,
      isCohortAssigned: false,
      isLoader: true,
      currentLocationId: '',
    }
  },
  watch: {
    '$route.params.location_id': async function (id) {
      this.currentLocationId = id
      await this.fetchLaunchpadLocationSegment()
    },
  },
  async created() {
    this.currentLocationId = this.$router.currentRoute.params.location_id
    if (this.currentLocationId) {
      await this.fetchLaunchpadLocationSegment()
    }
  },
  async mounted() {

  },
  computed: {
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
    checkCohortAssigned() {
      console.log('isCohortAssigned: ', this.isCohortAssigned)
      return this.isCohortAssigned
    },
    checkLoader() {
      return this.isLoader
    },
  },
  methods: {
    async fetchLaunchpadLocationSegment() {
      this.isLoader = true
      try {
        const data = await LaunchpadService.segmentDetailForLocation({
          locationId: this.currentLocationId,
          companyId: this.company?.id,
          userId: this.$store.state.auth.user?.userId
        })
        if ('segment' in data) {
          this.isCohortAssigned = true
        } else {
          this.isCohortAssigned = false
        }
      } catch (error) {
        // console.error(error)
      } finally {
        this.isLoader = false
      }
    }
  }
})
